export function generateDocDefinition(
  data,
  searchDate,
  jobSpecificTimes,
  jobSpecificTotals,
  columnsToShow,
  employeesToShow,
  jobs,
) {
  var startDate = new Date(searchDate[0]);
  var endDate = new Date(searchDate[1]);
  var formattedStartDate = startDate.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: '2-digit'
  });
  var formattedEndDate = endDate.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: '2-digit'
  });
  var dateRangeString = `${formattedStartDate} - ${formattedEndDate}`;

  var today = new Date();
  var dateString =
    today.toLocaleDateString('en-US') + ' ' + today.toLocaleTimeString('en-US');

  var showJobColumn = jobSpecificTotals.some(jobTotal =>
    jobTotal.data.some(hasJobHours)
  );

  var headers = [
    { text: 'Employee', style: 'tableHeader', alignment: 'center' }
  ];

  columnsToShow.forEach(column => {
    headers.push({
      text: column.name,
      style: 'tableHeader',
      alignment: 'center'
    });
  });

  if (showJobColumn) {
    headers.splice(1, 0, {
      text: 'Jobs',
      style: 'tableHeader',
      alignment: 'center'
    });
  }

  var body = [];
  // data.forEach(function(employee) {
  //   if (employee.total > 0 || showAllEmployees) {
  //     var employeeData = [
  //       { text: employee.employee.name, alignment: 'center' },
  //       { text: employee.total.toString(), alignment: 'center' },
  //       { text: employee.regularTotal.toString(), alignment: 'center' },
  //       { text: employee.otTotal.toString(), alignment: 'center' }
  //     ];

  //     if (showOnCallHours)
  //       employeeData.push({
  //         text: employee.onCallHoursTotal.toString(),
  //         alignment: 'center'
  //       });
  //     if (showStatHours)
  //       employeeData.push({
  //         text: employee.statTotal.toString(),
  //         alignment: 'center'
  //       });
  //     if (showTravelTime)
  //       employeeData.push({
  //         text: employee.travelTimeTotal.toString(),
  //         alignment: 'center'
  //       });

  //     body.push(employeeData);
  //     }})
  employeesToShow.forEach(function(employee) {
    var employeeRow = [{ text: employee.employee.name, alignment: 'center' }];

    if (showJobColumn) {
      employeeRow.push({ text: '', alignment: 'center' });
    }

    columnsToShow.forEach(column => {
      employeeRow.push({
        text: employee[column.dataName]
          ? employee[column.dataName].toFixed(2)
          : '0.00',
        alignment: 'center'
      });
    });

    body.push(employeeRow);

    if (jobSpecificTimes && showJobColumn) {
      const employeeJobs = jobSpecificTotals.find(
        item => item.employee.id === employee.employee.id
      );

      if (employeeJobs && employeeJobs.data.length > 0) {
        const jobHoursTotals = calculateJobHours(employeeJobs);
        for (const [jobId, hours] of Object.entries(jobHoursTotals)) {
          const jobName = getJobName(jobId, jobs);

          const jobDetailsRow = [
            { text: '', alignment: 'center' },
            { text: jobName, alignment: 'center' },
            { text: hours.regular.toFixed(2), alignment: 'center' },
            { text: hours.ot.toFixed(2), alignment: 'center' }
          ];

          while (jobDetailsRow.length < headers.length) {
            jobDetailsRow.push({ text: '', alignment: 'center' });
          }
          body.push(jobDetailsRow);
        }
      }
    }
  });

  //assigning values from the end due to the first two columns that do not have totals
  const totalColumns = headers.length;
  var totalsRow = Array(totalColumns).fill({ text: '', alignment: 'center' });
  totalsRow[0] = { text: 'Totals', alignment: 'center' };

  columnsToShow.forEach((column, index) => {
    totalsRow[totalColumns - columnsToShow.length + index] = {
      text: column.value.toFixed(2),
      alignment: 'center'
    };
  });
  body.push(totalsRow);

  var tableObject = {
    table: {
      headerRows: 1,
      widths: Array(headers.length).fill('*'),
      body: [headers].concat(body)
    },
    layout: {
      hLineWidth: function(i, node) {
        return i === 0 || i === node.table.body.length ? 1 : 0.5;
      },
      vLineWidth: function(i, node) {
        return i === 0 || i === node.table.widths.length ? 1 : 0.5;
      }
    }
  };

  var docDefinition = {
    content: [
      {
        columns: [
          {
            text: '',
            width: '*'
          },
          {
            text: 'Time Card Report',
            alignment: 'center',
            style: 'header'
          },
          {
            text: dateString,
            alignment: 'right',
            style: 'subheader'
          }
        ]
      },
      {
        text: dateRangeString,
        alignment: 'left',
        style: 'dateRange'
      },
      tableObject
    ],
    styles: {
      header: {
        fontSize: 16,
        bold: true,
        margin: [0, 10, 0, 30]
      },
      subheader: {
        fontSize: 9,
        bold: false,
        margin: [0, 10, 0, 10]
      },
      tableHeader: {
        bold: true,
        fontSize: 10
      },
      dateRange: {
        fontSize: 12,
        bold: true,
        margin: [0, 5, 0, 10]
      }
    }
  };

  return docDefinition;
  }

  function getJobName(id, jobs) {
    if (id && id !== 'default') {
      let job = jobs.find(x => x.id === id);
      return job ? job.description : '';
    }
    return null;
  }

  function calculateJobHours(employeeData) {
    const totals = {};

    employeeData.data.forEach(entry => {
      Object.keys(entry.regular).forEach(jobId => {
        if (!totals[jobId]) {
          totals[jobId] = { regular: 0, ot: 0 };
        }
        totals[jobId].regular += entry.regular[jobId];
      });

      Object.keys(entry.ot).forEach(jobId => {
        totals[jobId].ot += entry.ot[jobId];
      });
    });

    return totals;
  }

  function hasJobHours(job) {
    const hasRegularHours = Object.values(job.regular).some(hours => hours > 0);
    const hasOtHours = Object.values(job.ot).some(hours => hours > 0);
    return hasRegularHours || hasOtHours;
  }
